import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * List of all the users.
 *
 * @param dispatch
 * @param commit
 * @param payload
 * @returns {*}
 */
export function getUsers(_ref, payload) {
  var dispatch = _ref.dispatch,
    commit = _ref.commit;
  return dispatch('api', {
    url: 'users',
    wait: 'get-users',
    params: payload.params
  }, {
    root: true
  }).then(function (response) {
    commit('SET_DATA', {
      state: 'users',
      data: response.data.data
    });
    commit('SET_DATA', {
      state: 'meta',
      data: response.data.meta
    });
  });
}

/**
 * Delete user.
 *
 * @param dispatch
 * @param id
 * @returns {*}
 */
export function deleteUser(_ref2, id) {
  var dispatch = _ref2.dispatch;
  return dispatch('api', {
    url: 'users/' + id,
    method: 'delete',
    wait: 'delete-user'
  }, {
    root: true
  });
}

/**
 * Reset 2FA
 *
 * @param dispatch
 * @param id
 * @returns {*}
 */
export function reset2FA(_ref3, id) {
  var dispatch = _ref3.dispatch;
  return dispatch('api', {
    url: 'users/mfa/' + id,
    method: 'delete'
  }, {
    root: true
  });
}

/**
 * Create new user
 *
 * @param dispatch
 * @param payload
 * @returns {*}
 */
export function createUser(_ref4, payload) {
  var dispatch = _ref4.dispatch;
  return dispatch('api', {
    url: 'users',
    method: 'post',
    wait: 'user',
    avoidArrayJoin: true,
    data: _objectSpread({}, payload)
  }, {
    root: true
  });
}

/**
 * Update new user
 *
 * @param dispatch
 * @param payload
 * @returns {*}
 */
export function updateUser(_ref5, payload) {
  var dispatch = _ref5.dispatch;
  return dispatch('api', {
    url: 'users/' + payload.id,
    method: 'put',
    avoidArrayJoin: true,
    wait: 'user',
    data: _objectSpread({}, payload)
  }, {
    root: true
  });
}

/**
 * Toggle dialog visibility
 *
 * @param dispatch
 */
export function toggleDialog(_ref6) {
  var commit = _ref6.commit;
  commit('TOGGLE_DIALOG');
}

/**
 * List of all roles.
 *
 * @param dispatch
 * @param commit
 * @returns {*}
 */
export function getRoles(_ref7) {
  var dispatch = _ref7.dispatch,
    commit = _ref7.commit;
  return dispatch('api', {
    url: 'roles'
  }, {
    root: true
  }).then(function (response) {
    var data = response.data.data.map(function (_ref8) {
      var name = _ref8.name,
        id = _ref8.id;
      return {
        label: name,
        value: id
      };
    });
    commit('SET_DATA', {
      state: 'roles',
      data: data
    });
  });
}